import { render, staticRenderFns } from "./updateFBAInfo.vue?vue&type=template&id=b6e4cd6c&scoped=true&"
import script from "./updateFBAInfo.vue?vue&type=script&lang=js&"
export * from "./updateFBAInfo.vue?vue&type=script&lang=js&"
import style0 from "./updateFBAInfo.vue?vue&type=style&index=0&id=b6e4cd6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e4cd6c",
  null
  
)

export default component.exports